// extracted by mini-css-extract-plugin
module.exports = {"announcement":"styles_announcement__rAxWP","scrolled":"styles_scrolled__RrimJ","link":"styles_link__QPzxM","icon":"styles_icon__t3xGs","body":"styles_body__a7kz2"};